




























































import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

import Input from '@/components/atoms/Input.vue'
import { getCreditcardPaymentProvierServiceConfig } from '@/services/payment'
import MonthDropdown from '@spa/components/molecules/date/MonthDropdown.vue'
import YearDropdown from '@spa/components/molecules/date/YearDropdown.vue'
import CardOwnerForm from '@spa/components/organisms/payment/creditcard/CardOwnerForm.vue'
import { CreditcardFormState } from '@spa/components/organisms/payment/creditcard/creditcardFormState'
import SecurityCodeForm from '@spa/components/organisms/payment/creditcard/SecurityCodeForm.vue'

@Component({
  components: {
    SpaInput: Input,
    MonthDropdown,
    YearDropdown,
    CardOwnerForm,
    SecurityCodeForm,
  },
})
export default class CreditcardForm extends Vue {
  @Inject()
  readonly $validator: Validator

  @Prop({
    default: {
      cardNumber: '',
      cardOwner: '',
      expireMonth: '',
      expireYear: '',
      securityCode: '',
    },
  })
  readonly value: CreditcardFormState

  get registerCardForm() {
    return getCreditcardPaymentProvierServiceConfig().viewConfig.registerCardForm
  }
  get showCardOwner(): boolean {
    return this.registerCardForm.requireCardOwner
  }
  get showSecurityCode(): boolean {
    return this.registerCardForm.requireSecurityCode
  }

  onInputCardNumber(value: string): void {
    this.$emit('card-number-change', value)
  }

  onInputCardOwner(value: string): void {
    this.$emit('card-owner-change', value)
  }

  onInputExpireMonth(value: string): void {
    this.$emit('expire-month-change', value)
  }

  onInputExpireYear(value: string): void {
    this.$emit('expire-year-change', value)
  }

  onInputSecurityCode(value: string): void {
    this.$emit('security-code-change', value)
  }
}
